import React from 'react'
import _, { isNil } from 'lodash'
import axios from 'axios'
import Dropzone from 'react-dropzone'

import { csrfToken } from 'Utilities/Csrf'
import Alert from 'Components/Alert'
import { cloudhelpGet } from '../../utilities/CloudHelp';

//
// Create your attachments controller nested under your object as an API
// <Attachments object={problem} admin={problemAdmin} />
//

class Attachments extends React.Component {
  constructor (props) {
    super(props)

    this.removeAttachment = this.removeAttachment.bind(this)
    this.gatherAttachments = this.gatherAttachments.bind(this)
    this.attachableType = props.object.href?.split('/')[1] || props.object.url?.split('/')[1]
    this.state = {
      attachments: [],
      showAlert: false,
      errorType: '',
      errorText: ''
    }
  }

  componentDidMount () {
    this.gatherAttachments()
  }

  onDrop (e) {
    const file = e[0]
    const { gatherAttachments } = this
    const { object, user_token } = this.props
    const formData = new FormData()

    formData.append(`${this.attachableType.slice(0, -1)}[file]`, file)
    formData.append('authenticity_token', csrfToken())
    formData.append('user_token', user_token)

    axios.post(`/${this.attachableType}/${object.id}/attachments.json`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then((response) => {
        gatherAttachments().then(() => {
          this.setState({
            showAlert: true,
            errorType: 'info',
            errorText: response.data.message
          })
        })
      })
      .catch(() => {
        this.setState({
          showAlert: true,
          errorType: 'error',
          errorText: 'Attachment failed to add'
        })
      })
  }

  gatherAttachments () {
    const { object, user_token } = this.props

    return cloudhelpGet(`${object.href || object.url}/attachments`, { user_token })
      .then((response) => {
        const { attachments } = response.data
        this.setState({ attachments })
      })
  }

  removeAttachment (attachment) {
    const { gatherAttachments } = this
    const { user_token } = this.props
    const { recordId, id } = attachment
    const parameters = {
      params: {
        utf8: '√',
        authenticity_token: csrfToken(),
        user_token,
        [`${this.attachableType.slice(0, -1)}_id`]: recordId
      }
    }

    axios.delete(`/${this.attachableType}/${recordId}/attachments/${id}.json`, parameters)
      .then((response) => {
        gatherAttachments().then(() => {
          this.setState({
            showAlert: true,
            errorType: 'info',
            errorText: response.data.message
          })
        })
      })
      .catch(() => {
        this.setState({
          showAlert: true,
          errorType: 'error',
          errorText: 'Attachment failed to delete'
        })
      })
  }

  showAttachment = (attachment) => {
    const { user_token, object } = this.props

    let url = `${object.href || object.url}/attachments/${attachment.id}`
    if (user_token) { url = `${url}?user_token=${user_token}` }

    window.open(url, '_blank')
  }

  render () {
    const { attachments, showAlert, errorType, errorText } = this.state
    const { showAttachment } = this

    const { admin } = this.props
    const attachmentsList = _.map(attachments, attachment => (
      <li key={attachment.id} className="attachments__item">
        <span
          onClick={() => showAttachment(attachment)}
          className="link"
          rel="noopener"
        >
          {attachment.name}
        </span>
        {admin &&
          (
            <span
              href="javascript:;"
              className="lnr lnr-trash2 lnr-black"
              onClick={() => {
                if (window.confirm('Are you sure you want to delete this attachment?')) {
                  this.removeAttachment(attachment)
                }
              }}
            />
          )
        }
      </li>
    ))

    return (
      <div>
        { admin &&
          (
            <div>
              <Alert text={errorText} alertType={errorType} showAlert={showAlert} />
              <div className="add-correspondence">
                <div className="add-correspondence__footer">
                  <div className="add-correspondence--text flex">
                    <Dropzone className="dropzone" onDrop={this.onDrop.bind(this)}>
                      <a href="javascript:;" className="add-correspondence__footer--link">
                        Attach files
                      </a>
                    </Dropzone>
                    <small>
                      (limit 5MB)
                    </small>
                  </div>
                </div>
              </div>
            </div>
          )
        }

        { !_.isEmpty(attachments) && (
          <ul className="list list--no-list-style list--no-padding attachments">
            {attachmentsList}
          </ul>
        )}
      </div>
    )
  }
}

export default Attachments
